<app-header title="Manage Events"></app-header>
<div class="container pt-5 mt-5">
    <div class="d-flex justify-content-between align-items-center mb-2">
        <div class="campaign__title">Your Events</div>
        <div class="campaign__action-list d-flex flex-column">
            <button class="btn btn--paybee btn-sm modal-confirm-button mb-3" (click)="createNewEvent()">New Event</button>
            <button class="btn btn--paybee btn--outline-transparent d-flex align-items-center cursor-pointer" style="font-size: 14px;" (click)="onAMClick()">
                <i class="fas fa-desktop mr-2"></i>
                <div>Manage Audience Monitor</div>
            </button>
        </div>
    </div>
</div>
<div class="container mb-2">
    <div class="switch">
        <form [formGroup]="form">
            <app-mdb-switch label="All Events" formControlName="switcher"></app-mdb-switch>
        </form>
    </div>
</div>
<div style="background-color: #FFFFFF;">
    <div class="container">
        <ng-container *ngIf="events$ | async as events">
            <div class="w-100" style="height: 1px"></div>
            <div class="event mt-3" style="border-bottom: 1px solid #EEEFF2" *ngFor="let event of getFilteredEventList(events)">
                <div class="event__name d-flex align-items-center mb-2">
                    <div class="event__name text-truncate">{{getEventName(event)}}</div>
                </div>
                <div class="event_body pb-3">
                    <div class="row">
                        <div class="col-sm-3 col-lg-4">
                            <img [src]="getEventImageUrl(event)" alt="" class="event__image w-100" />
                        </div>
                        <div class="col-sm-9 col-lg-8 d-flex justify-content-between">
                            <div class="pr-5 mr-5">
                                <div class="event__characteristic d-flex align-items-center">
                                    <div class="event__characteristic-name mr-2">Status</div>
                                    <ng-container [ngSwitch]="getEventStatus(event)">
                                        <div
                                            class="event__characteristic-value event__characteristic-value--green position-relative px-2 py-1"
                                            *ngSwitchCase="0"
                                        >
                                            <div class="event__characteristic-background event__characteristic-background--green position-absolute h-100 w-100"></div>
                                            Active
                                        </div>
                                        <div
                                            class="event__characteristic-value event__characteristic-value--red position-relative px-2 py-1"
                                            *ngSwitchCase="1"
                                        >
                                            <div class="event__characteristic-background event__characteristic-background--red position-absolute h-100 w-100"></div>
                                            Deactivated
                                        </div>
                                    </ng-container>
                                </div>
                                <div class="event__characteristic d-flex">
                                    <div class="event__characteristic-name mr-2">Type</div>
                                    <div class="event__characteristic-value">{{ getEventType(event) }}</div>
                                </div>
                                <div class="event__action-list d-flex mb-3">
                                    <ng-container *ngIf="event.type === 1 || event.type === 2">
                                        <button
                                            type="button"
                                            class="campaign__action d-block btn btn--paybee btn--outline-transparent w-100"
                                            (click)="onClickRun(event)"
                                        >
                                            <i class="fas fa-tv mr-2"></i>
                                            Run...
                                        </button>
                                    </ng-container>
                                </div>
                                <div class="event__action-list d-flex justify-content-between mb-3">
                                    <button
                                        type="button"
                                        class="campaign__action btn btn--paybee btn--outline-transparent mr-2"
                                        (click)="onEditEvent(event)"
                                    >Edit...</button>
                                    <ng-container *ngIf="event.type === 0">
                                        <ng-container [ngSwitch]="event.inPersonEventInfo.status">
                                            <button
                                                type="button"
                                                class="campaign__action btn btn--paybee btn--outline-transparent mr-2"
                                                *ngSwitchCase="0"
                                                (click)="deleteEvent(event, true)"
                                            >Deactivate</button>
                                            <button
                                                type="button"
                                                class="campaign__action btn btn--paybee btn--outline-transparent mr-2"
                                                *ngSwitchCase="1"
                                                (click)="deleteEvent(event, false)"
                                            >Activate</button>
                                        </ng-container>
                                    </ng-container>
                                    <ng-container *ngIf="event.type === 1">
                                        <ng-container [ngSwitch]="event.virtualEventInfo.status">
                                            <button
                                                type="button"
                                                class="campaign__action btn btn--paybee btn--outline-transparent mr-2"
                                                *ngSwitchCase="0"
                                                (click)="deleteEvent(event, true)"
                                            >Deactivate</button>
                                            <button
                                                type="button"
                                                class="campaign__action btn btn--paybee btn--outline-transparent mr-2"
                                                *ngSwitchCase="1"
                                                (click)="deleteEvent(event, false)"
                                            >Activate</button>
                                        </ng-container>
                                    </ng-container>
                                    <ng-container *ngIf="event.type === 2">
                                        <ng-container [ngSwitch]="event.hybridEventInfo.status">
                                            <button
                                                type="button"
                                                class="campaign__action btn btn--paybee btn--outline-transparent mr-2"
                                                *ngSwitchCase="0"
                                                (click)="deleteEvent(event, true)"
                                            >Deactivate</button>
                                            <button
                                                type="button"
                                                class="campaign__action btn btn--paybee btn--outline-transparent mr-2"
                                                *ngSwitchCase="1"
                                                (click)="deleteEvent(event, false)"
                                            >Activate</button>
                                        </ng-container>
                                    </ng-container>
                                    <app-actions-popover-event [event]="event"></app-actions-popover-event>
                                </div>
                                <div class="event__action-list d-flex mb-3">
                                  <button
                                    type="button"
                                    class="campaign__action btn btn--paybee btn--outline-transparent mb-2 w-100"
                                    (click)="onClickEventLinks(event)"
                                  >
                                    <span>Event Links...</span>
                                  </button>
                                </div>
                            </div>
                            <ng-container>
                                <div class="d-flex align-items-center flex-column">
                                    <div class="event__actions" style="min-width: 200px;">
                                        <div class="event__actions-header m-2 text-center">Invitation & Links</div>
                                        <div class="event__actions-type mb-2" *ngIf="event.type > 0">
                                            <div class="col text-center green-text" *ngIf="getVirtualEventType(event) === 0">Open Event</div>
                                            <div class="col text-center red-text" *ngIf="getVirtualEventType(event) === 1">Closed Event</div>
                                        </div>
                                        <div
                                            *ngIf="event.type === 1 || event.type === 2"
                                            class="d-flex w-100"
                                        >
                                            <app-shared-link-event-popover *ngIf="getVirtualEventType(event) === 0" [event]="event"></app-shared-link-event-popover>
                                        </div>
                                        <div
                                            *ngIf="event.type === 1 || event.type === 2"
                                            class="d-flex w-100"
                                        >
                                            <app-shared-rsvplink-event-popover *ngIf="getVirtualEventType(event) === 0" [event]="event"></app-shared-rsvplink-event-popover>
                                        </div>
                                        <div class="d-flex w-100">
                                            <app-send-invitation-event-popover [event]="event"></app-send-invitation-event-popover>
                                        </div>
                                    </div>
                                    <div *ngIf="event.type > 0" class="event__actions-type-description text-center text-truncate mt-1">
                                        {{getEventTypeDescription(event)}}
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>
